import DocumentList from "../components/document/DocumentCrud";

const DocumentCrudPage = () => {
  return (
    <>
      <DocumentList />
    </>
  );
};

export default DocumentCrudPage;
